import { render, staticRenderFns } from "./EmailTemplateEdit.vue?vue&type=template&id=5600cd40&scoped=true&"
import script from "./EmailTemplateEdit.vue?vue&type=script&setup=true&lang=js&"
export * from "./EmailTemplateEdit.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5600cd40",
  null
  
)

export default component.exports